/* @flow */
import { takeLatest, takeEvery, call, put, fork, all } from 'redux-saga/effects'
import { error, success } from 'react-notification-system-redux'
import { I18n } from 'react-redux-i18n'
import moment from 'moment'
import _ from 'lodash'

import {
  GET_ACTIVITIES,
  GET_ACTIVITIES_SUCCESS,
  GET_ACTIVITIES_FAILURE,
  // CLOUD_ACTIVITIES_IMG_FOLDER,
  WRITE_COMMENT,
  SEND_COMMENT_SUCCESS,
  ADD_ACTIVITY_TO_FAVORITE,
  REMOVE_ACTIVITY_FROM_FAVORITE,
  UPDATE_ACCOUNT_FAVORITES_SUCCESS,
} from '../configs/constants'
import API from '../libs/api'

const api = new API()

/* Workers */
export function* fetchActivities() {
  try {
    const activities = yield call([api, api.readDBOnce], '/activities')
    _.forEach(activities, activity => {
      if (activity.photos && activity.photos.length) {
        activity.photos = _.map(activity.photos, photo => (photo.url ? photo.url : photo))
        // activity.thumb = yield call([api, api.getStorageUrl], CLOUD_ACTIVITIES_IMG_FOLDER + activity.photos[0])
      }
    })
    yield put({ type: GET_ACTIVITIES_SUCCESS, activities })
  } catch (err) {
    yield put({ type: GET_ACTIVITIES_FAILURE, err })
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
  }
}

function* pushComment({ type, comment }) {
  try {
    const { whole, profession, service, comfort, value, commentTitle, commentContent, activityId, orderId, creator, creatorName } = comment
    const activityPath = '/activities/' + activityId
    // Count Avg.
    const avg = (whole + profession + service + comfort + value) / 5
    const comments = yield call(api.readDBOnce, activityPath + '/comments')
    const total = _.sumBy(comments, 'avg')
    const latestAvg = (total + avg) / (((comments && comments.length) || 0) + 1)
    const newComment = {
      avg, whole, profession, service, comfort, value,
      title: commentTitle || '', content: commentContent || '',
      creator, creatorName, createdTime: moment().toISOString()
    }
    if (comments) {
      yield call([api, api.pushDB], activityPath + '/comments', newComment)
    } else {
      yield call(api.writeDB, activityPath + '/comments', [newComment])
    }
    yield all([
      call(api.updateDB, '/orders/' + orderId, { comment: newComment }),
      call(api.updateDB, activityPath, { rating: latestAvg })
    ])
    yield put(success({ message: I18n.t('sendCommentSuccss') }))
    yield put({ type: SEND_COMMENT_SUCCESS, payload: { orderId: orderId, comment: newComment } })
  } catch (err) {
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
  }
}

export function* addToFavorite({ payload }) {
  try {
    const favoritePath = '/accounts/' + payload.account.uid + '/favorites'
    yield call([api, api.pushDB], favoritePath, { activityId: payload.activityId })
    const favorites = yield call([api, api.readDBOnce], favoritePath)
    yield put({ type: UPDATE_ACCOUNT_FAVORITES_SUCCESS, favorites })
    yield put(success({ message: I18n.t('addFavoriteSuccess') }))
  } catch (err) {
    yield (put(error({ title: 'Error: ' + err.code, message: err.message })))
  }
}

export function* removeFavorite({ payload }) {
  try {
    const favoritePath = '/accounts/' + payload.account.uid + '/favorites/' + payload.key
    let newFavorites = payload.account.favorites
    delete newFavorites[payload.key]
    yield call(api.removeFromDB, favoritePath)
    yield put(success({ message: I18n.t('removeFavoriteSuccess') }))
    yield put({ type: UPDATE_ACCOUNT_FAVORITES_SUCCESS, favorites: newFavorites })
  } catch (err) {
    yield put(error({ title: 'Remove Favorite Encounters an Error: ' + err.code, message: err.message }))
  }
}

/* Watchers */
function* activityWatcher() {
  yield takeLatest(GET_ACTIVITIES, fetchActivities)
}
function* writeCommentWatcher() {
  yield takeEvery(WRITE_COMMENT, pushComment)
}

function* addToFavoriteWatcher() {
  yield takeLatest(ADD_ACTIVITY_TO_FAVORITE, addToFavorite)
}

function* removeFavoriteWatcher() {
  yield takeLatest(REMOVE_ACTIVITY_FROM_FAVORITE, removeFavorite)
}

export default [
  fork(activityWatcher),
  fork(writeCommentWatcher),
  fork(addToFavoriteWatcher),
  fork(removeFavoriteWatcher),
]


// WEBPACK FOOTER //
// ./src/sagas/activitySaga.js